"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PropertyMapper_1 = require("./PropertyMapper");
class NetworkStatistics {
    constructor() {
        this.time = new Date();
        this.nrOfActiveWatchers = 0;
        this.nrOfActiveValidators = 0; //validators that are validating
        this.nrOfActiveFullValidators = 0;
        this.nrOfActiveOrganizations = 0;
        this.transitiveQuorumSetSize = 0;
        this.hasTransitiveQuorumSet = false;
        this.minBlockingSetFilteredSize = 0;
        this.hasSymmetricTopTier = false;
    }
    static fromJSON(networkStatsObject) {
        const networkStatistics = new NetworkStatistics();
        PropertyMapper_1.default.mapProperties(networkStatsObject, networkStatistics, [
            'time'
        ]);
        networkStatistics.time = new Date(networkStatsObject.time);
        return networkStatistics;
    }
}
exports.default = NetworkStatistics;
//# sourceMappingURL=network-statistics.js.map